import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { FormWrapper } from 'libs/forms/styles';

import { Divider } from 'legacyComponents/styled/lib';
import { ProTip } from 'apps/components/shared';
import { ButtonGroup } from 'legacyComponents/styles';

import Button from 'components/Button';

export const MainSignInPageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const ImageWrapper = styled.div`
  width: 65%;
  max-height: 100vh;
  object-fit: cover;
  overflow: hidden;

  img {
    width: 100%;
  }

  ${media.m`
    display: none;
  `}
`;

export const WrapperSignInForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-content: center;

  ${media.m`
    width: 100%;
  `}
`;

export const MainSignInFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => props.theme.spacing.large};
  min-width: 400px;
  max-width: 400px;

  ${media.m`
    min-width: 600px;
  `}
  ${media.s`
    min-width: 440px;
  `}
  ${media.xs`
    min-width: 280px;
  `}
`;

export const SignInFormWrapper = styled(FormWrapper)`
  padding: 0;
`;

export const FormDivider = styled(Divider)`
  width: 600px;
  ${media.m`
    width: calc(100% - 30px);
  `}
`;

export const SignInButtonGroup = styled(ButtonGroup)`
  flex-direction: column;
  margin: ${props => props.theme.spacing.default} 0;
`;

export const NoAccount = styled(ProTip)`
  color: ${props => props.theme.color.wfGrey900};
`;

export const ButtonStyled = styled(Button)`
  margin: ${props => `${props.theme.spacing.default} 0`};
`;

export const WikifactorySignInButton = styled(NoAccount)`
  color: ${props => props.theme.color.primary};
  text-decoration: underline;
  cursor: pointer;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${props => props.theme.spacing.large};
`;

export const FooterLabel = styled.div`
  font-size: ${props => props.theme.font.size.default};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
`;

export const GoBackWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${props => props.theme.spacing.large};
  display: flex;
  flex-direction: row;
`;

export const MainWrapperSocialButtons = styled.div`
  margin: ${props => `${props.theme.spacing.default}`} 0
    ${props => `${props.theme.spacing.default}`};
  display: flex;
  flex-direction: row;
`;

export const WrapperSocialButton = styled.div`
  margin-right: ${props => props.theme.spacing.small};
`;

export const SingleOAuthButton = styled(Button)`
  margin: ${props => props.theme.spacing.default} 0
    ${props => props.theme.spacing.default} 0;
`;
